import React from 'react';

import { cssMap } from '@atlaskit/css';
import { FlagsProvider } from '@atlaskit/flag';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import {
	AIDisclaimer,
	AIFeedbackComponent,
	AIFeedbackPropertiesProvider,
} from '@atlassian/ai-components';

import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';

const AUDIO_FEEDBACK_ENTRYPOINT_ID = 'ffb1f355-3d3c-45c7-a0d1-1f13eb13baa3';

const styles = cssMap({
	footerWrapper: {
		paddingInline: token('space.100'),
		paddingBlockStart: token('space.025'),
		paddingBlockEnd: token('space.075'),
	},
});

export const AudioFeedbackFooter = (): React.JSX.Element => {
	const { activeContent, activeFeature } = useAudioPlayerStore();

	return (
		<FlagsProvider>
			<AIFeedbackPropertiesProvider
				entrypointId={AUDIO_FEEDBACK_ENTRYPOINT_ID}
				feedbackContext={{
					feature: activeFeature,
					isTeamEUVersion: true,
				}}
			>
				<Inline
					spread="space-between"
					grow="fill"
					alignBlock="start"
					alignInline="center"
					xcss={styles.footerWrapper}
				>
					<AIDisclaimer />
					<AIFeedbackComponent contentId={activeContent.contentId} />
				</Inline>
			</AIFeedbackPropertiesProvider>
		</FlagsProvider>
	);
};
